import Vue from 'vue';
import vueRouter from 'vue-router';
import routes from './routes.js';
Vue.use(vueRouter);

export default new vueRouter({
    routes,
});



// WEBPACK FOOTER //
// ./src/router/index.js